/**
 * Fetch distinct equipment_type values from gateway_register_maps for profile form dropdowns.
 */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useGatewayRegisterMapTypes() {
  const query = useQuery({
    queryKey: ['gateway-register-map-types'],
    queryFn: async (): Promise<string[]> => {
      const { data, error } = await supabase
        .from('gateway_register_maps')
        .select('equipment_type')
        .order('equipment_type');
      if (error) throw new Error(error.message);
      const set = new Set((data ?? []).map((r: { equipment_type: string }) => r.equipment_type));
      return Array.from(set);
    },
    staleTime: 5 * 60_000,
  });
  return {
    equipmentTypes: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error as Error | null,
  };
}
